"use client";

import { c as _c } from "react/compiler-runtime";
import type { Offer } from "@local/offer/src/types";
import { cn } from "@local/utils/src/cn";
import { useForm } from "react-hook-form";
import { useParams } from "next/navigation";
import { getT } from "@local/i18n/src/t";
import { getLanguageForMarket } from "@local/i18n/src/languages";
import { home } from "@local/i18n/src/catalogs/home";
import { Button } from "../../ui/Button";
import { ContentBlock } from "../../ui/ContentBlock";
import { mailerSignupAction } from "./action";
const BRAND_NAME = "BÆRSkin Tactical Supply Co.";
export interface MailerSignupProps {
  content: Offer.MailerSignup;
  channel: string;
}
interface FormValues {
  terms: string;
  email: string;
}
export const MailerSignup = t0 => {
  const $ = _c(10);
  const {
    content,
    channel
  } = t0;
  const market = useParams().market as string | undefined;
  const t = getT(getLanguageForMarket(market), {
    home
  });
  const {
    register,
    handleSubmit,
    formState: t1
  } = useForm();
  const {
    isSubmitting,
    errors,
    isSubmitted
  } = t1;
  let t2;
  if ($[0] !== channel) {
    t2 = async t3 => {
      const {
        email
      } = t3;
      await mailerSignupAction(email, channel);
    };
    $[0] = channel;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const submit = t2;
  const consentText = t("home.mailerConsent", {
    name: BRAND_NAME
  });
  const T0 = ContentBlock;
  const t3 = "mx-auto mb-4";
  const t4 = "mx-4 flex flex-col items-center justify-center rounded-md bg-gray-100 px-16 py-10 lg:mx-8";
  let t5;
  if ($[2] !== content.headline) {
    t5 = <h3 className="text-h3 leading-heading-tight mb-8 w-5/6 text-center font-semibold">{content.headline}</h3>;
    $[2] = content.headline;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = isSubmitted ? <p>{t("home.mailerThankYou")}</p> : <form onSubmit={handleSubmit(submit)} className="w-full text-center"><div className="mb-3 flex flex-col items-center justify-center gap-4 md:flex-row"><div className="relative w-5/6"><div className="absolute -top-10 flex w-full justify-center">{errors && (errors.email || errors.terms) && <div className={cn("text-Color__Text__Problem z-10 w-fit rounded-md bg-red-200 px-3 py-1 shadow-md transition-all", "[&_.ErrorTooltip]:z-10", "[&_.ErrorTooltip]:hover:absolute [&_.ErrorTooltip]:hover:bottom-0 [&_.ErrorTooltip]:hover:left-1/2 [&_.ErrorTooltip]:hover:z-0 [&_.ErrorTooltip]:hover:h-3 [&_.ErrorTooltip]:hover:w-3 [&_.ErrorTooltip]:hover:translate-x-[-50%] [&_.ErrorTooltip]:hover:translate-y-[50%] [&_.ErrorTooltip]:hover:rotate-45 [&_.ErrorTooltip]:hover:transform [&_.ErrorTooltip]:hover:bg-red-200 [&_.ErrorTooltip]:hover:shadow-2xs [&_.ErrorTooltip]:hover:content-[\"\"]")}>{errors.email?.message}{errors.terms?.message}</div>}</div><input type="email" required={true} aria-required={true} aria-label={t("home.mailerEmailLabel")} {...register("email", {
          required: true
        })} placeholder={t("home.mailerEmailPlaceholder")} className="border-Color__Border__Input border-Width__Border__Input h-12 w-full rounded-lg bg-white px-4 text-center text-base placeholder-gray-500 md:text-lg" /></div><Button type="submit" disabled={isSubmitting} className="w-full max-w-[360px]">{isSubmitting ? t("home.mailerSubmitting") : t("home.mailerSubmit")}</Button></div><div className="flex flex-row items-center justify-center md:flex-row"><input aria-label={t("home.mailerConsentAria")} aria-required={true} type="checkbox" {...register("terms", {
        required: true
      })} defaultChecked={true} className="mr-2 mb-2 h-5 w-5 md:mb-0" required={true} /><label htmlFor="agree">{consentText}</label></div></form>;
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== T0 || $[8] !== t7) {
    t8 = <T0 className={t3}>{t7}</T0>;
    $[7] = T0;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
};